import axios from 'axios';
import { Base64 } from 'js-base64';
import $AES from '../utils/AES';
import { hex_md5 } from "@/common/js/md5.js";
import router from "../router"
import Toast from "@nutui/nutui/dist/packages/toast/toast.js";
import '@nutui/nutui/dist/packages/toast/toast.css';

const toTokenTip = () => {
  router.push("/user/token")
}
const toLogin = () => {
    router.push("/user/login")
}

function genUUID(adid) {
  let random =
    Math.floor(
      (Math.random() + Math.floor(Math.random() * 9 + 1)) *
      Math.pow(10, 4 - 1)
    ) + "";
  let time = new Date().getTime() + "";
  return adid + "H5" + time + "" + random;
}
function getData(params) {
  let data = {}
  let device = JSON.parse(localStorage.getItem("device"));
  let userInfo = localStorage.getItem("userInfo")?JSON.parse(localStorage.getItem("userInfo")):"";
  let adid = localStorage.getItem("adid");
  //params由通用参数device、adid和接口指定参数组成
  params.device = device;
  params.adId = adid;
  if(userInfo&&userInfo.uid){
    params.uid = userInfo.uid;
  }
  // console.log(params)

  var timestamp = new Date().getTime() + '';
  var nonce = genUUID(adid);

  data.timestamp = Base64.encode(timestamp);
  data.nonce = Base64.encode(nonce);

  var defKey = "EQqwglntFurSkGK39VmEVEQqwglntFur";

  var contentKeyStr = nonce.substring(nonce.length - 6, nonce.length) + timestamp.substring(timestamp.length - 4, timestamp.length) + defKey.substring(defKey.length - 6, defKey.length);

  let valAes = $AES.encrypt(JSON.stringify(params), contentKeyStr);//需进行AES加密（不同接口还需加入必传参数）
  data.content = Base64.encode(valAes);

  var signatureStr = nonce + timestamp + valAes;
  data.signature = hex_md5(signatureStr).toUpperCase();
  return data;
}

export default function ajax(url, data = {}, isToken) {
  return new Promise(function (resolve, reject) {
    // 执行异步ajax请求
    let promise;
    data = getData(data)

    // 发送post请求
    if (isToken) {
      let token = localStorage.getItem("token") ? localStorage.getItem("token") : ''
      promise = axios.post(url, data, {
        headers: {
          'token': token
        }
      })
    } else { promise = axios.post(url, data,) }

    promise.then(function (response) {
      if (response.data.code == 401 || response.data.code == 403) {
        localStorage.removeItem("userInfo")
        localStorage.removeItem("token")
        // toTokenTip();
        Toast.text('登陆过期，请重新登录')
        setTimeout(()=>{
          toLogin()
        },1000)
      } else {
        // 成功了调用resolve()
        resolve(response.data)
      }

    }).catch(function (error) {
      //失败了调用reject()
      reject(error)
    })
  })
}



// WEBPACK FOOTER //
// ./src/api/ajax.js